import request from "./curl";

var notification_utility = {
  /**
   * notification_dialog_android
   * Get & Sync to DB only for android. This is required because when the user opens the settings,
   * Android devices notification activity starts for user to do settings. On returning from this activity,
   * there is no way to return the settings back to user. So we start a time inside the below method and on expiry
   * the settings are retrieved from android device and synced to the backend. But it may happen that the user
   * may do the settings after expiry. So new settings are not synced to the backend DB. On mounted get and sync to backend
   * 
   */
  async notification_dialog_android(context, group_id, group_name) {
    await window.androidBridge.group_notification_setting_set(group_id, group_name);

    setTimeout(() => {
      //default
      let notification = "1";
      let sound = "0";

      let settings = window.androidBridge.group_notification_setting_get(group_id);
      if(settings != "false"){
        if (settings.indexOf("mImportance=0") !== -1) {
          //mImportance=0 - Disable Notification 
          notification = "0";
        }

        if (settings.indexOf("mSound=null") == -1) {
          //mSound=null -   Disable Sound else sound is on
          sound = "1";
        }
      }

      notification_utility.group_notification_save(context, group_id, notification, sound);
      //Since there is no way to return settings from "window.androidBridge.group_notification_setting_set", 
      //get the settings after 15 Secs and save it in the backend DB       
    }, 15000);
  },
  /**
   * group_notification_save
   */
  group_notification_save(context, group_id, notification, sound) {
    context.loading = true;
    context.err_msg = '';
    var setting_data = new FormData();
    setting_data.append("chat_user_id", context.userData.user_id);
    setting_data.append("group_id", group_id);
    setting_data.append("notification", notification);
    setting_data.append("sound", sound);

    request.curl(context, "group_setting_set", setting_data)
      .then(response => {
        if (response.resp_status) {
          let settings = response.resp_data.body.settings;
          notification_utility.update_group_notification_setting_chatgrp_list(context, settings);
          context.snackbar = true;
          context.err_msg = 'Notification settings have been saved'
          context.loading = false;
          context.dialog = false;
        }
      });
  },
  /**
   * update_group_notification_setting_chatgrp_list
   */
  async update_group_notification_setting_chatgrp_list(context, settings) {
    let grp_list = await context.getChatgrpList;
    let selectedGroup_id = await context.selectedGroup;

    if (grp_list && grp_list.length > 0) {
      let grp_index = grp_list.findIndex((grp) => { return grp.group_id == selectedGroup_id });
      let grp_details = grp_list[grp_index];
      grp_details.settings = settings;
      grp_list[grp_index] = grp_details;
      //save groups to ls;
      context.$store.commit('setChatgrpList', grp_list);
    }
  },
};

export default notification_utility;
